import { ContinueWithGoogleProps } from '.';
import styled from 'styled-components';

import { typography } from '@/styles/helpers';

export const ScContinueWithGoogle = styled.div<
  Partial<ContinueWithGoogleProps>
>`
  display: flex;
  flex-direction: column;
  gap: ${({ dividerGap }) => (dividerGap === 'small' ? '16px' : '32px')};
  margin-bottom: ${({ marginBottom }) =>
    marginBottom === 'small' ? '16px' : '24px'};

  .image {
    margin-right: 8px;
  }

  .text {
    font-size: 16px;
  }
`;

export const ScDivider = styled.div`
  ${typography['body2regular']}
  color: ${({ theme }) => theme.grayMegaLightColor};
  display: flex;
  align-items: center;

  &::before,
  &::after {
    flex: 1;
    content: '';
    padding: 0.5px;
    background-color: ${({ theme }) => theme.grayMegaLightColor};
  }

  &::before {
    margin-right: 12px;
  }
  &::after {
    margin-left: 12px;
  }
`;
